export default {
	locations: [],
	checkedLocations: [],
	terminals: [],
	dialog: false,
	fromDialog: ''
};
